const ProductCPTypes = {
  GET_ALL_SUPPLIERS: 'PCP_GET_ALL_SUPPLIERS',
  GET_INDIVIDUAL_DETAILS: 'GET_INDIVIDUAL_DETAILS',
  CLEAR_REDUCER: 'CLEAR_REDUCER',
  GET_UNARCHIVED_CARDS: 'GET_UNARCHIVED_CARDS',
  ALL_PRODUCTCP_TABLIST: 'ALL_PRODUCTCP_TABLIST',
  GET_ALL_TAB_COLUMDATA: 'GET_ALL_TAB_COLUMDATA',
  CLEAR_TABS: 'CLEAR_TABS',
  GET_PCP_LOGS: 'GET_PCP_LOGS',
  CLEAR_LOGS_REDUCER: 'CLEAR_LOGS_REDUCER',
  GET_TAB_COLUMNS: 'GET_TAB_COLUMNS',
  CLEAR_INDIVIDUAL_REDUCER: 'CLEAR_INDIVIDUAL_REDUCER',
  GET_NEW_CALCULATION: 'GET_NEW_CALCULATION',
  GET_COLUMN_FILTER: 'GET_COLUMN_FILTER',
  CLEAR_TABLE_REDUCER: 'CLEAR_TABLE_REDUCER',
};

export default ProductCPTypes;
